module.exports = __webpack_public_path__ + "img/login_bg.3447b424.png";